module.exports = __webpack_public_path__ + "img/1sb-loader_icon.e5e1763.svg";